import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    trackDetailViewSelector, visibleTracksSelector,
    highlightedDriveSelector, trackDataSelector,
} from '../../../features/datacenter/historySlice';
import { setNeedBounding } from '../../../features/map/mapSlice';

const GoogleMapTrackBounder = ({ map }) => {
    const dispatch = useDispatch();
    const trackDetailView = useSelector(trackDetailViewSelector);
    const visibleTracks = useSelector(visibleTracksSelector);
    const highlightedDrive = useSelector(highlightedDriveSelector);
    const trackData = useSelector(trackDataSelector);

    useEffect(() => {
        const mapBounder = () => {
            if (map && window.google) {
                let bounds = new window.google.maps.LatLngBounds();
                if (visibleTracks.length > 0) {
                    if (highlightedDrive.startIndex !== null && highlightedDrive.endIndex !== null && trackDetailView) {
                        //console.log("drive bound", highlightedDrive);
                        const route = trackData[trackDetailView].track;
                        route.forEach((r, i) => {
                            if (i >= highlightedDrive.startIndex && i <= highlightedDrive.endIndex) {
                                const point = new window.google.maps.LatLng(r.lat, r.lng);
                                bounds.extend(point);
                            }
                        })
                        map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
                    } else if (trackDetailView) {
                        //console.log("Track bound", trackDetailView);
                        const route = trackData[trackDetailView].track;
                        if (route) {
                            route.forEach((r, i) => {
                                const point = new window.google.maps.LatLng(r.lat, r.lng);
                                bounds.extend(point);
                            })
                            map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
                            dispatch(setNeedBounding(false));
                        }

                    } else {
                        //console.log("all bound");
                        visibleTracks.forEach(v => {
                            if (trackData[v]) {
                                const route = trackData[v] && trackData[v].track;
                                route.forEach((r, i) => {
                                    const point = new window.google.maps.LatLng(r.lat, r.lng);
                                    bounds.extend(point);
                                })
                                map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
                            }
                        })
                        dispatch(setNeedBounding(false));
                    }
                }
            }

        };
        mapBounder();
    }, [dispatch, map, highlightedDrive, trackDetailView, visibleTracks, trackData])

    return (
        <div></div>
    );
}

export default GoogleMapTrackBounder;